<template>
  <div class="form-container">
    <div class="background">
      <div class="left"></div>
      <div class="right"></div>
    </div>
    <div class="container">
      <h3>Хотите отдохнуть в Японии?</h3>
      <p>
        Подпишитесь на новости о лучших ценах и предложениях от Japan Airlines.
      </p>
      <form @submit.prevent="submit">
        <input type="email" v-model="email" required placeholder="Ваш e-mail" />
        <button type="submit"></button>
      </form>
      <div class="subtext">
        Нажимая кнопку, я соглашаюсь на обработку персональных данных <br />
        и получение рассылки от JAL
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { db } from "../db";

export default {
  name: "Form",
  firebase: {
    emails: db.ref("emails")
  },
  data() {
    return {
      email: null
    };
  },
  methods: {
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    submit() {
      if (!this.isEmail(this.email)) {
        return false;
      }
      this.$swal({
        title: "Ваша заявка принята",
        type: "success",
        customClass: "alert"
      });

      this.$ga.event(
        "Форма",
        "Успешная отправка формы",
        "Успешная отправка формы"
      );

      this.$firebaseRefs.emails.push({
        email: this.email
      });

      axios.post("/send_email.php", { email: this.email });

      this.email = null;
    }
  }
};
</script>

<style lang="scss">
.alert {
  border-radius: 0 !important;
  &.swal2-popup .swal2-title {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    margin: 0;
    color: #000000;
    line-height: 26px;
    text-align: left;
    text-transform: uppercase;
  }
  button {
    border-radius: 0 !important;
    font-family: "Roboto", sans-serif;
  }
}
.form-container {
  position: relative;
  height: 180px;
  overflow: hidden;

  .background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    z-index: -1;

    .left {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100px;
      height: 100px;
      background: url("../assets/form-left.png");
    }
    .right {
      position: absolute;
      right: 0;
      top: 0;
      width: 273px;
      height: 180px;
      background: url("../assets/form-right.png");
    }
  }
  .container {
    width: 460px;
    margin: 0 80px 0;
  }

  h3 {
    font-size: 16px; /* Приближение из-за подстановки шрифтов */
    font-weight: 500;
    line-height: 24px; /* Приближение из-за подстановки шрифтов */
    text-align: left;
    margin: 20px 0 0;
  }

  p {
    font-size: 14px; /* Приближение из-за подстановки шрифтов */
    font-weight: 400;
    line-height: 24px; /* Приближение из-за подстановки шрифтов */
    text-align: left;
    margin: 0;
  }

  input {
    margin-top: 12px;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    border: #959595 solid 1px;
    background-color: #ffffff;
  }

  form {
    position: relative;
    display: block;
  }
  button {
    border: 0;

    background: url("../assets/arrow.png");
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    width: 26px;
    height: 11px;
    z-index: 120;
    opacity: 0.4;
    right: 20px;
    top: 50%;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  .subtext {
    text-align: right;
    font-size: 12px; /* Приближение из-за подстановки шрифтов */
    font-weight: 400;
    line-height: 17px;
    padding-right: 30px;
    opacity: 0.5;
  }
}

@media screen and (max-width: 669px) {
  .form-container {
    height: 230px;
    margin-top: 0;
    padding-top: 17px;
    .background {
      .left {
        display: none;
      }

      .right {
        background: url("../assets/form-right-m.png");
        width: 180px;
        height: 230px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right bottom;
      }
    }

    .container {
      width: 100%;
      margin: 0 19px;

      h3 {
        font-size: 14px; /* Приближение из-за подстановки шрифтов */
        font-weight: 500;
        line-height: 17px; /* Приближение из-за подстановки шрифтов */
      }

      p {
        font-size: 14px;
        line-height: 20px;
        width: 77%;
      }

      form {
        width: calc(100% - 78px);

        input {
          margin-top: 15px;
          padding: 5px;
        }
        button {
          right: 10px;
          top: 52%;
        }
      }
    }
    .subtext {
      text-align: left;
      line-height: 16px;
      width: 66%;
      font-size: 12px;
      margin-top: 7px;
    }
  }
}
</style>
